module.exports = __webpack_public_path__ + "static/media/driver-licence.bbd5b9ef.svg";